import Reveal from "@/components/Reveal";
import storefrontAvif640 from "@/assets/storefront-640.avif";
import storefrontAvif852 from "@/assets/storefront-852.avif";
import storefrontWebp640 from "@/assets/storefront-640.webp";
import storefrontWebp852 from "@/assets/storefront-852.webp";

const AboutSection = () => {
  return (
    <section id="about" className="py-20">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal from="left">
            <div className="rounded-2xl overflow-hidden" style={{ boxShadow: "var(--shadow-hero)" }}>
              <picture>
                <source
                  type="image/avif"
                  srcSet={`${storefrontAvif640} 640w, ${storefrontAvif852} 852w`}
                  sizes="(min-width: 1024px) 50vw, 100vw"
                />
                <img
                  src={storefrontWebp852}
                  srcSet={`${storefrontWebp640} 640w, ${storefrontWebp852} 852w`}
                  sizes="(min-width: 1024px) 50vw, 100vw"
                  alt="Computer Zone storefront in Marietta, Georgia"
                  width={852}
                  height={1846}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-[360px] object-cover"
                />
              </picture>
            </div>
          </Reveal>

          <Reveal from="right" delay={0.1}>
            <p className="text-primary-strong font-semibold text-sm uppercase tracking-widest mb-3">About Computer Zone</p>
            <h2 className="font-display text-3xl md:text-4xl font-extrabold text-foreground mb-6">
              Doing Right For Over 24 Years
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              It all begins with an idea. In 2001, Computer Zone was founded by the Amedee Family because they saw a need in the community to provide support for the fast-paced tech world. Located at 3079 Roswell Rd in Marietta, GA, over 24 years later, countless people have been helped.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We offer free PC checkups, repairs, upgrades, onsite services, laptop repair, web design and hosting, and much more. Your satisfaction is our top priority, and we won't rest until we've delivered the solution you need.
            </p>
            <p className="text-foreground font-semibold leading-relaxed mb-8">
              Every repair starts with a free 15-minute diagnostic — no commitment, no pressure, just honest answers from Marietta's trusted tech team.
            </p>
            <div className="grid grid-cols-3 gap-6">
              {[
                { num: "24+", label: "Years" },
                { num: "10K+", label: "Devices Fixed" },
                { num: "5★", label: "Google Rating" },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-display text-2xl font-extrabold text-primary">{stat.num}</p>
                  <p className="text-xs text-muted-foreground mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
